




if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
      
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        
        
        const formData = new FormData(this.form);
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }     
        this.cartItems = [];
        
        // if (bundleGroups.length > 0) {
        //   bundleGroups.forEach((group) => {
        //     const inputs = group.querySelectorAll('input');
        //     const properties = {};
        //      const product = {};
        
        //     inputs.forEach((input) => {
        //       const label = input.placeholder || input.name; // Use placeholder as key (e.g. "Full Name", "Email Address")
        //       const value = input.value.trim();
        
        //       if (value) {
        //         properties[label] = value;
        //       }
        //     });
        
        //     if (Object.keys(properties).length > 0) {
        //         product.id = sharedProductId;
        //         product.quantity = 1;
        //        product.properties = properties;
        //        this.cartItems.push(product);
        //     }            
        //   });
        //    }
        const findclose = this.closest('.product-right-container');
      const bundleGroups = findclose.querySelectorAll('.attendee-input-group');
      const qtytotal = parseInt(findclose.querySelector('.personenanzahl').value); 
      const sharedProductId = formData.get('id');
        const select = findclose.querySelector('.product-form__input .select select');
        const selectedValue = select?.value?.trim() || '';
        console.log(selectedValue,"selectedValue");
        console.log(bundleGroups,"bundleGroups");
      if (qtytotal) {
          for (let i = 0; i < qtytotal; i++) {
              const group = bundleGroups[i]; 
              const properties = {};
      
              if (group) {
                  const inputs = group.querySelectorAll('input');
                  const dateist = this.querySelector('.date-list'); 
                  console.log(dateist,"dateist")
                  inputs.forEach((input) => {
                      const label = input.placeholder || input.name;
                      const value = input.value.trim();
                      if (value) {
                          properties[label] = value;
                      
                         if (dateist && selectedValue == 'Online-Seminar') {
                            properties['Date'] =   dateist.value;
                          }
                          properties['_time'] = Date.now()+i;
                      }
                  });
              }else{
                 properties['_time'] = Date.now()+i;
              }
      
              const product = {
                  id: sharedProductId,
                  quantity: 1,
                  properties:properties
              };
      
              this.cartItems.push(product);
          }
      
          const ADDTOCART_OBJECT = { items: this.cartItems };
          custom_addtocart(ADDTOCART_OBJECT, true,this);
          return true;
      }
 
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButton.querySelector('span').innerHTML = text;
        } else {
          const container = document.querySelector('.attendee-fields-container');
          const inputs = container.querySelectorAll('input');
          

        if (inputs.length > 0) {
          const allFilled = Array.from(inputs).every(input => input.value.trim() !== '');
        
          if (allFilled) {
            this.submitButton.removeAttribute('data-variant-unavalable');
          } else {
            this.submitButton.setAttribute('data-variant-unavalable', '');
          }
        }
          this.submitButton.removeAttribute('disabled');
          this.submitButton.querySelector('span').innerHTML = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
